import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { AffiliatePayloadType } from "@/common/types/affiliate";

export async function affiliateList(account_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/affiliate/list${queryString}`,
  );
}

export async function affiliateCreate(
  account_id: string,
  payload: AffiliatePayloadType,
) {
  return await clientAxios.post(
    `account/${account_id}/affiliate/create`,
    payload,
  );
}

export async function affiliateUpdate(
  account_id: string,
  affilate_id: string,
  payload: AffiliatePayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/affiliate/${affilate_id}/update`,
    payload,
  );
}

export async function affiliateDelete(account_id: string, affilate_id: string) {
  return await clientAxios.del(
    `account/${account_id}/affiliate/${affilate_id}/delete`,
  );
}
